module.exports = __webpack_public_path__ + "img/category_sisustus.133f53a6.webp";